<div>

  <div *ngIf="!indicator.uid.isRegistered" class="alert alert-info font-small text-center" role="alert">
    {{ 'NEW_INDICATOR_CREATE/TEXT' | translate }}
  </div>

  <app-links-item *ngFor="let element of list" [color]="color" [icon]="icon" [labels]="element.labels" [uid]="element.uid">
    <div app-links-item-content-description>
    </div>
    <div app-links-item-content-option>
      <app-links-item-option class="d-block mx-1" [uid]="element.uid.value" [symbol]="'check'" [selected]="indicator.uid.value == element.uid.value" (sendSelected)="receiveSelected($event)"></app-links-item-option>
    </div>
  </app-links-item>

</div>

<app-empty app-browser-frame-content-list [action]="false" [type]="'indicators'" *ngIf="list != undefined && list.length == 0"></app-empty>
<app-loading app-browser-frame-content-list *ngIf="list == undefined"></app-loading>